// extracted by mini-css-extract-plugin
export default {"textContainer":"Text_textContainer__SkYIH","markdown":"Text_markdown__FNu6E"};